/**
 * THE PIECES EVERY STEP 3 QUESTIONS SCREEN SHARES (owner-approved colour polish, mock-up version 3, 23 Oct 2026):
 * a navy number circle before each question, the title in navy, one "suggested" marker, and a quiet line under
 * the heading for anyone who would rather build the plan themselves. One file, so all six modules stay alike.
 */
import React from 'react';

/** The question's number in a small navy circle; the number is still read out by screen readers. */
export const QuestionNumber = ({ n }: { n: number }) => (
    <span className="inline-grid h-[26px] w-[26px] shrink-0 place-items-center rounded-full bg-brand-navy text-[13px] font-bold text-white" aria-hidden="true" data-testid="question-number">{n}</span>
);

/** A numbered question title: the circle, then the title (and anything that follows it, such as "what's this?"). */
export const QuestionTitle = ({ n, children, as: Tag = 'h4', className = '' }: { n: number; children: React.ReactNode; as?: 'h4' | 'p'; className?: string }) => (
    <Tag className={`flex items-start gap-2.5 text-[15px] font-semibold text-brand-navy ${className}`}>
        <QuestionNumber n={n} />
        <span className="min-w-0 pt-[2px]"><span className="sr-only">{n}. </span>{children}</span>
    </Tag>
);

/** The one "suggested" marker: a small green outline pill. */
export const SuggestedTag = ({ className = 'ml-2' }: { className?: string }) => (
    <span className={`inline-block whitespace-nowrap rounded-full border border-emerald-600/60 px-2 align-middle text-[11px] font-bold leading-[18px] text-emerald-700 ${className}`} data-testid="suggested-tag">suggested</span>
);

/** Under the heading: the way to skip the questions and build the plan by hand (owner, 23 Oct 2026). */
export const BuildYourselfLine = ({ onClick, testId }: { onClick: () => void; testId?: string }) => (
    <p className="mt-1.5 text-[13.5px] text-slate-600" data-testid={testId}>
        Rather set the numbers yourself?{' '}
        <button type="button" onClick={onClick} className="font-semibold text-brand-navy underline decoration-slate-300 underline-offset-4 hover:decoration-brand-navy">Build a plan yourself</button>
        {' '}and skip these questions.
    </p>
);
